export default __webpack_public_path__ + "static/media/22.e85295f8.mp3";